import { render, staticRenderFns } from "./index.vue?vue&type=template&id=faa0ec22&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=faa0ec22&prod&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=faa0ec22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa0ec22",
  null
  
)

export default component.exports